import { render, staticRenderFns } from "./DialogAddLecturesHall.vue?vue&type=template&id=b2a02c32"
import script from "./DialogAddLecturesHall.vue?vue&type=script&lang=js"
export * from "./DialogAddLecturesHall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Nevo.SimAdmin.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2a02c32')) {
      api.createRecord('b2a02c32', component.options)
    } else {
      api.reload('b2a02c32', component.options)
    }
    module.hot.accept("./DialogAddLecturesHall.vue?vue&type=template&id=b2a02c32", function () {
      api.rerender('b2a02c32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogAddLecturesHall.vue"
export default component.exports